import { useHistory, useLocation } from "react-router-dom";
import useQuery from "../useQuery/useQuery";

const parseStrArray = (str: string | null | undefined): string[] => {
    if (!str) {
        return [];
    }

    return str
        .split(",")
        .map((s) => s.trim())
        .filter(Boolean);
};

export const useHierarchicalNavigation = (currentIdParam: string, previousIdsParam: string) => {
    const history = useHistory();
    const { pathname } = useLocation();
    const params = useQuery([currentIdParam, previousIdsParam]);

    const currentId = params[currentIdParam] || "";
    const previousIds = parseStrArray(params[previousIdsParam] || "");

    const move = (id: string) => {
        const newPreviousIds = [...previousIds, currentId].join(",");

        history.push(`${pathname}?${currentIdParam}=${id}&${previousIdsParam}=${newPreviousIds}`);
    };

    const back = () => {
        if (previousIds.length) {
            history.goBack();
        } else {
            history.replace(pathname);
        }
    };

    return { move, back };
};
